module.exports = __webpack_public_path__ + "img/kr.kr6bd5eda.svg";